<template>
    <div class="customSelect" :class="{ miniSelect: miniSelect }" ref="root">
        <div
            class="customSelect__top"
            @click="openBotMethod"
            :class="{ customTop: openBot, withoutBorder: isBorder }"
        >
            <p>{{ displayedLabel }}</p>
            <img src="@/assets/icons/select.svg" />
        </div>

        <div class="customSelect__bot" v-if="openBot && list && isAddFile">
            <div
                class="customSelect__bot__in"
                v-for="item in list"
                :key="item.id ?? item.type ?? item.title"
                @click="selectItem(item)"
            >
                {{ item.title }}
            </div>
        </div>

        <div class="customSelect__bot second" v-if="openBot && list && !isAddFile">
            <div
                class="customSelect__bot__in"
                v-for="item in list"
                :key="item.id ?? item.type ?? item.title"
                @click="selectItem(item)"
            >
                {{ item.title || item.fio }}
            </div>
        </div>
    </div>
</template>

<script>
const CUSTOM_SELECT_OPENED = 'custom-select-opened';

export default {
    name: 'CustomSelect',
    props: {
        isBorder: Boolean,
        miniSelect: Boolean,
        isAddFile: Boolean,
        isFilter: Boolean,
        isRisk: Boolean,
        isDisabled: Boolean,
        list: { type: Array, default: () => [] },
        modelValue: { default: null },
        selectedItem: { type: String, default: 'Выбор' }
    },
    emits: ['update:modelValue', 'change'],
    data() {
        return { openBot: false };
    },
    computed: {
        displayedLabel() {
            const v = this.modelValue;
            if (v === null || v === undefined || v === '') return this.selectedItem;

            if (this.isAddFile) {
                const found = this.list.find(i => String(i.type) === String(v));
                return found ? (found.title || this.selectedItem) : this.selectedItem;
            }

            const found = this.list.find(i => String(i.id) === String(v));
            return found ? (found.title || found.fio || this.selectedItem) : this.selectedItem;
        }
    },

    mounted() {
        // 1) если открылся другой select — закрываемся
        this._onSelectOpened = (e) => {
            const openedUid = e?.detail?.uid;
            if (openedUid !== this._uid) {
                this.openBot = false;
            }
        };
        window.addEventListener(CUSTOM_SELECT_OPENED, this._onSelectOpened);

        // 2) клик вне компонента — закрываемся
        this._onClickOutside = (e) => {
            if (!this.openBot) return;

            const root = this.$refs.root;
            if (root && !root.contains(e.target)) {
                this.openBot = false;
            }
        };

        document.addEventListener('click', this._onClickOutside, true);
    },

    beforeUnmount() {
        window.removeEventListener(CUSTOM_SELECT_OPENED, this._onSelectOpened);
        document.removeEventListener('click', this._onClickOutside, true);
    },

    // если проект ещё на Vue 2:
    beforeDestroy() {
        window.removeEventListener(CUSTOM_SELECT_OPENED, this._onSelectOpened);
        document.removeEventListener('click', this._onClickOutside, true);
    },

    methods: {
        openBotMethod() {
            if (this.isDisabled) return;

            // Если собираемся открыть — сначала сообщаем всем остальным закрыться
            if (!this.openBot) {
                window.dispatchEvent(
                    new CustomEvent(CUSTOM_SELECT_OPENED, {
                        detail: { uid: this._uid }
                    })
                );
            }

            this.openBot = !this.openBot;
        },

        selectItem(item) {
            const valueToEmit = this.isAddFile ? item.type : item.id;

            this.$emit('update:modelValue', valueToEmit);
            this.$emit('change', item);

            this.openBot = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.customTop {
    border-radius: 10px 10px 0px 0px;
}
.withoutBorder {
    border: none !important;
}
.miniSelect {
    .customSelect__top {
        padding: 5px 10px;
    }
    .customSelect__bot__in {
        padding: 5px;
        p {
            padding: 0 10px;
        }
    }
}
@media (max-width: 768px) {
    .customSelect {
        &__top {
            p{
                font-size: 16px!important;
            }
        }
    }
}
.customSelect {
    width: 100%;
    display: flex;
    cursor: pointer;
    flex-direction: column;
    position: relative;
    &__top {
        padding: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px)min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
        width: 100%;
        background-color: transparent;
        display: flex;
        justify-content: space-between;
        gap: 10px;
        border-radius: 10px;
        border: 1px solid #0000001A;
        white-space: nowrap;
        overflow: hidden;
        font-size: 16px;
        text-overflow: ellipsis;
        p {
            margin: 0;
            flex-grow: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    &__bot {
        width: 100%;
        top: 100%;
        border: 1px solid #0000001A;
        border-radius: 10px;
        max-height: 200px;
        overflow: auto;
        position: absolute;
        background-color: #F0F2F5;
        z-index: 999;
        &__in {
            cursor: pointer;
            padding: 10px;
            border-radius: 10px;
            p {
                padding: 0 min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
            }
            transition: all 0.5s ease;
            &:hover {
                background-color: #F8F8F8;
                color: black;
            }
        }
    }
}
</style>